import {
  GenerateWebsocketAuthToken,
  GenerateWebsocketAuthTokenVariables
} from './__generated__/GenerateWebsocketAuthToken'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation GenerateWebsocketAuthToken($deviceId: String!, $pairingCode: String!) {
    generateWebsocketAuthTokenV2(deviceId: $deviceId, pairingCode: $pairingCode)
  }
`

export const useGenerateWebsocketAuthToken = () => {
  return useMutation<GenerateWebsocketAuthToken, GenerateWebsocketAuthTokenVariables>(MUTATION)
}
